import { render, staticRenderFns } from "./H5HorizontalImageWall.vue?vue&type=template&id=461bbbac&scoped=true"
import script from "./H5HorizontalImageWall.vue?vue&type=script&lang=js"
export * from "./H5HorizontalImageWall.vue?vue&type=script&lang=js"
import style0 from "./H5HorizontalImageWall.vue?vue&type=style&index=0&id=461bbbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bbbac",
  null
  
)

export default component.exports